import React, { useState, ChangeEvent } from 'react';
import {Card, Form, Input, Button, Space, Row, Col} from 'antd';
import {DeleteOutlined} from "@ant-design/icons";
import {getLabelWithNameAndInfotext} from "../../../utils/Utils";

interface StringOperationsProps {
    selectedFunction: string;
    onSave: (expression: string) => void;
}

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const StringFunctions: React.FC<StringOperationsProps> = ({ selectedFunction, onSave }) => {
    const [argumentsList, setArgumentsList] = useState<string[]>(['', '']);

    const handleAddArgument = () => {
        setArgumentsList([...argumentsList, '']);
    };

    const handleRemoveArgument = (index: number) => {
        const newArgs = argumentsList.filter((_, i) => i !== index);
        setArgumentsList(newArgs);
    };

    const handleArgumentChange = (index: number, event: ChangeEvent<HTMLInputElement>) => {
        const newArgs = [...argumentsList];
        newArgs[index] = event.target.value;
        setArgumentsList(newArgs);
    };


    const handleSave = () => {
        let expression = '';
        if (selectedFunction === 'substring') {
            expression = `${selectedFunction}(${argumentsList[0]};${argumentsList[1]};${argumentsList[2]})`;
        } else if (selectedFunction === 'split') {
            expression = `${selectedFunction}(${argumentsList[0]};${argumentsList[1]};${argumentsList[2]})`;
        } else {
            expression = `${selectedFunction}(${argumentsList.join(';')})`;
        }
        onSave(expression);
    };

    const resolveFunctionName = (selectedFunction) => {
        switch (selectedFunction){
            case 'concat':
                return 'Verketten';
            case 'substring':
                return 'Teilstring';
            case 'split':
                return 'Trennen';
        }
    }

    return (
        <Card title={`Funktion: ${resolveFunctionName(selectedFunction)}`} bordered={false}>
            {selectedFunction !== 'substring' && selectedFunction !== 'split' && (
                <>
                    <Form.Item label="Argumente">
                        {argumentsList.map((arg, index) => (
                            <Space key={index} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                <Input
                                    value={arg}
                                    onChange={(e) => handleArgumentChange(index, e)}
                                    style={{ marginBottom: 8 }}
                                />
                                <Button danger onClick={() => handleRemoveArgument(index)}><DeleteOutlined /></Button>
                            </Space>
                        ))}
                        {selectedFunction === 'concat' && (
                            <Button onClick={handleAddArgument}>Argument hinzufügen</Button>
                        )}
                    </Form.Item>
                </>
            )}
            {selectedFunction === 'substring' && (
                <div>
                    <Form.Item label="Text" labelCol={{ span: 7 }}
                               wrapperCol={{ span: 17 }}>
                        <Input
                            value={argumentsList[0]}
                            onChange={(e) => handleArgumentChange(0, e)}
                        />
                    </Form.Item>
                    <Form.Item label={getLabelWithNameAndInfotext("Start-Index", "Startposition ist die 0", "z.B. Um die letzten Buchstaben 'st' von 'Test' zu erhalten: 2-4",
                    "Start-Index inklusiv")} labelCol={{ span: 7 }}
                               wrapperCol={{ span: 17 }}>
                        <Input
                            value={argumentsList[1]}
                            onChange={(e) => handleArgumentChange(1, e)}
                        />
                    </Form.Item>
                    <Form.Item label={getLabelWithNameAndInfotext("Ende-Index", "z.B. Um die letzten Buchstaben 'st' von 'Test' zu erhalten: 2-4",
                        "Ende-Index exklusiv", "Sollte hier kein Wert angegeben werden, so der restliche String verwendet")} labelCol={{ span: 7 }}
                               wrapperCol={{ span: 17 }}>
                        <Input
                            value={argumentsList[2]}
                            onChange={(e) => handleArgumentChange(2, e)}
                        />
                    </Form.Item>
                </div>
            )}
            {selectedFunction === 'split' && (
                <div>
                        <Form.Item labelCol={{ span: 7 }}
                                   wrapperCol={{ span: 17 }} label="Text">
                            <Input
                                value={argumentsList[0]}
                                onChange={(e) => handleArgumentChange(0, e)}
                            />
                        </Form.Item>
                        <Form.Item labelCol={{ span: 7 }}
                                   wrapperCol={{ span: 17 }} label={getLabelWithNameAndInfotext("Trennzeichen", "z.B. P1-P2, dort würde sich das - Zeichen anbieten", "Trennzeichen wird entfernt")} >
                            <Input
                                value={argumentsList[1]}
                                onChange={(e) => handleArgumentChange(1, e)}
                            />
                        </Form.Item>
                        <Form.Item labelCol={{ span: 7 }}
                                   wrapperCol={{ span: 17 }} label={getLabelWithNameAndInfotext("Index", "z.B. Bei P1-P2, wäre P1 = 0, P2 = 1" , "Es wird mit 0 angefangen zu Zählen!")}>
                            <Input
                                value={argumentsList[2]}
                                onChange={(e) => handleArgumentChange(2, e)}
                            />
                        </Form.Item>
                </div>
            )}




            <Button type="primary" onClick={handleSave}>Speichern</Button>
        </Card>
    );
};

export default StringFunctions;
